import { useCallback, useEffect, useState } from 'react';
import dayjs from 'dayjs';
import api from '../utils/api.util';
import toast from '../utils/toast.util';
import { useAuth } from '../auth/AuthContext';
import { ENDPOINT } from '../constants/common-app.const';
import { GroupState, TrainingGroup } from '../pages/CourseEnrollment/CourseEnrollment.const';

const transformGroup = (g: any, idx: number): TrainingGroup => {
  const now = dayjs();
  const start = dayjs(g.startDate);
  const end = dayjs(g.endDate);
  const isActive = (now.isAfter(start) || now.isSame(start, 'day')) && (now.isBefore(end) || now.isSame(end, 'day'));

  const state: GroupState = isActive ? 'open' : g.status === 'open' ? 'open' : g.status === 'forming' ? 'forming' : 'waiting';

  return {
    id: g.id,
    name:
      idx === 0 && (isActive || g.status === 'open' || g.status === 'forming')
        ? 'Текущая группа'
        : `Группа ${g.sequenceNo}/${g.year}`,
    startDate: start.format('DD.MM.YYYY'),
    endDate: end.format('DD.MM.YYYY'),
    state,
  };
};

const useGetCourseGroups = ({ courseId }: { courseId: string }) => {
  const [groups, setGroups] = useState<TrainingGroup[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const { isAuthenticated } = useAuth();

  const fetchGroups = useCallback(async () => {
    try {
      setLoading(true);
      const response = await api.get(`${ENDPOINT.COURSES}/${courseId}/groups`);
      setGroups((response ?? []).map(transformGroup));
      setLoading(false);
    } catch (err) {
      toast.showOnFailure('Ошибка загрузки групп курса');
      setError('fetch failed');
      setLoading(false);
    }
  }, [courseId]);

  useEffect(() => {
    if (isAuthenticated && courseId) {
      fetchGroups();
    }
  }, [isAuthenticated, courseId, fetchGroups]);

  return { groups, loading, error };
};

export default useGetCourseGroups;
